import { fetchCart } from './theme.js';

async function CartProgressBar(html, event) {
  let progressBar = document.querySelector('cart-progress-bar');
  if (html) {
    progressBar = html.querySelector('cart-progress-bar');
  }
  if (!progressBar) return;
  const currentPosition = progressBar.dataset.currentPosition;
  const giftsData = JSON.parse(window.atob(progressBar.dataset.giftsData) || []);
  const giftsToAdd = giftsData.filter((gift) => gift.should_be_added);
  const giftsToRemove = giftsData.filter((gift) => gift.should_be_removed);

  if (giftsToAdd.length > 0) {
    const cart = event?.detail?.cart ?? (await fetchCart);
    const raw = cart?.attributes?._removed_gifts;
    const removedGifts = typeof raw === 'string' && raw.trim() !== '' ? raw.split(',') : [];

    const items = giftsToAdd.flatMap((item) => {
      const itemGraphQlId = `gid://shopify/ProductVariant/${item.id}`;
      return removedGifts.includes(itemGraphQlId) ? [] : [{ id: item.id, quantity: 1 }];
    });

    addToCartHandler(items, 'add');
  }

  if (giftsToRemove.length > 0) {
    let updates = {};
    giftsToRemove.forEach((item) => (updates[item.id] = 0));
    addToCartHandler(updates, 'update');
  }

  handleProgressPotion(currentPosition);
}

async function addToCartHandler(items, type) {
  const url = `${Shopify.routes.root}cart/${type}.js`;
  let sectionsToBundle = new Set();
  document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

  let formData = {
    sections: [...sectionsToBundle].join(','),
  };
  type === 'add' ? (formData.items = items) : (formData.updates = items);

  const request = {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': 'no-cors',
    },
    body: JSON.stringify(formData),
  };

  const response = await fetch(url, request);
  const result = await response.json();

  if (response.ok) {
    const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    cartContent['sections'] = result['sections'];
    const items = result.hasOwnProperty('items') ? result['items'] : [result];
    document.documentElement.dispatchEvent(
      new CustomEvent('variant:add', {
        bubbles: true,
        detail: {
          items,
          cart: cartContent,
        },
      }),
    );
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          cart: cartContent,
        },
      }),
    );
  }
}

function handleProgressPotion(currentPosition) {
  if (!currentPosition) return;
  const container = document.querySelector('cart-drawer');
  if (!container) return;

  setTimeout(() => {
    container.style.setProperty('--current-position', `${currentPosition}%`);
  });
}

async function handleGWP() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;
  const promoData = cartDrawer.getAttribute('data-promo');
  if (!promoData) return;
  const promoJSON = JSON.parse(window.atob(promoData));
  const cart = await fetchCart;
  const discounts = cart.discount_codes;
  const items = cart.items;
  const mathedCode = discounts.find((code) => code.code.toLowerCase() === promoJSON.discountCode.toLowerCase());
  const mathedLineItem = items.find((item) => item.variant_id === promoJSON.variantID);
  if (mathedCode && !mathedLineItem) {
    const items = [
      {
        id: promoJSON.variantID,
        quantity: 1,
      },
    ];
    await addToCartHandler(items, 'add');
  }

  if (!mathedCode && mathedLineItem) {
    const updates = {
      [promoJSON.variantID]: 0,
    };
    await addToCartHandler(updates, 'update');
  }
}

async function handleEmptyCart(event) {
  const cart = event.detail.cart;
  if (!cart) return;
  const attributes = cart.attributes;
  if (!attributes.hasOwnProperty('_removed_gifts') || cart.items.length > 0) return;
  const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      attributes: {
        _removed_gifts: '',
      },
    }),
  });
  const cartContent = await response.json();
}

document.documentElement.addEventListener('cart:change', (e) => {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer) return;
  const sectionId = cartDrawer.dataset.id;
  const cartDrawerRow = e.detail.cart.sections[sectionId];
  if (!cartDrawerRow) return;
  const parser = new DOMParser().parseFromString(cartDrawerRow, 'text/html');
  CartProgressBar(parser, e);
  handleEmptyCart(e);
});

document.addEventListener('cart:refresh', (e) => handleGWP());

document.addEventListener('DOMContentLoaded', () => {
  CartProgressBar();
  handleGWP();
});
